import React from 'react'
import ArrowSvg from './Svg/StraightArrowShortMobileSvg'
import { SxProps } from '@mui/system'

interface Props {
  doNotFlow?: boolean
  directionIsReversed?: boolean
  sx?: SxProps
}

const StraightArrowShort: React.FC<Props> = ({ doNotFlow, directionIsReversed, sx }) => {
  const direction = doNotFlow ? undefined : directionIsReversed ? 'out' : 'in'
  const transform = 'translateX(0)'
  const combinedSx = { width: 'fit-content', ...sx }
  return <ArrowSvg transform={transform} sx={combinedSx} direction={direction} />
}

export default StraightArrowShort
